import React, { useState, useEffect } from 'react';
import { gameAPI } from '../api/game';

/**
 * KingsCrossPage.jsx
 * صفحه «به‌زودی» ایستگاه کینگزکراس — بعد از عبور موفق از سکوی ۹ و ۳/۴.
 * تمام متن این صفحه از پنل ادمین (site_messages) قابل ویرایش است؛ هیچ متنی
 * هاردکد نیست (به‌جز مقادیر پیش‌فرض fallback که سرور در صورت نبود تنظیمات
 * برمی‌گرداند).
 *
 * توجه: بازی کامل بعد از ورود به هاگوارتز (سوار قطار شدن، چت گروهی و...) که
 * از قبل در سایت وجود دارد (JourneyPage/trainRoutes) دست‌نخورده باقی مانده
 * است — این صفحه فقط جایگزین لینک مستقیم به آن است تا زمانی که مرحله بعدی
 * ماجراجویی آماده شود.
 */
export default function KingsCrossPage() {
  const [status, setStatus] = useState('loading'); // loading | ready | error
  const [title, setTitle] = useState('');
  const [body, setBody] = useState('');

  useEffect(() => {
    gameAPI.getKingsCrossStatus()
      .then((res) => {
        const d = res.data;
        if (d.success) {
          setTitle(d.title);
          setBody(d.body);
          setStatus('ready');
        } else {
          setStatus('error');
        }
      })
      .catch(() => setStatus('error'));
  }, []);

  return (
    <div style={styles.root}>
      <div style={styles.stars} aria-hidden="true">
        {Array.from({ length: 50 }).map((_, i) => (
          <span
            key={i}
            style={{
              position: 'absolute',
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              width: 2, height: 2,
              borderRadius: '50%',
              background: '#fff',
              opacity: 0.3 + Math.random() * 0.5
            }}
          />
        ))}
      </div>

      <div style={styles.card}>
        <div style={styles.seal}>🚉</div>

        {status === 'loading' && <p style={styles.muted}>در حال بارگذاری...</p>}

        {status === 'error' && (
          <>
            <h1 style={styles.title}>ایستگاه کینگزکراس</h1>
            <p style={styles.body}>این بخش از ماجراجویی هنوز در حال ساخت است. کمی بعد دوباره سر بزن.</p>
          </>
        )}

        {status === 'ready' && (
          <>
            <h1 style={styles.title}>{title}</h1>
            <p style={styles.body}>{body}</p>
          </>
        )}

        <div style={styles.comingSoonBadge}>🛠️ به‌زودی</div>

        <a href="/" style={styles.linkBtn}>بازگشت به صفحه اصلی</a>
      </div>
    </div>
  );
}

const styles = {
  root: {
    minHeight: '100vh',
    background: 'radial-gradient(ellipse at top, #1a1a2e 0%, #050508 70%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',
    padding: 24,
    direction: 'rtl',
    fontFamily: "'Vazirmatn', 'Segoe UI', Tahoma, sans-serif"
  },
  stars: { position: 'absolute', inset: 0 },
  card: {
    position: 'relative',
    zIndex: 1,
    maxWidth: 480,
    width: '100%',
    background: 'rgba(20,20,32,0.85)',
    border: '1px solid rgba(212,175,55,0.35)',
    borderRadius: 16,
    padding: '40px 28px',
    textAlign: 'center',
    boxShadow: '0 8px 40px rgba(0,0,0,0.5)'
  },
  seal: { fontSize: '3.5rem', marginBottom: 16 },
  title: { color: '#d4af37', fontSize: '1.6rem', marginBottom: 16, fontWeight: 700 },
  body: { color: '#ddd', fontSize: '1rem', lineHeight: 1.9, marginBottom: 24 },
  muted: { color: '#888' },
  comingSoonBadge: {
    display: 'inline-block',
    background: 'rgba(212,175,55,0.15)',
    color: '#d4af37',
    border: '1px solid rgba(212,175,55,0.4)',
    borderRadius: 20,
    padding: '6px 18px',
    fontSize: '0.85rem',
    marginBottom: 24
  },
  linkBtn: {
    display: 'block',
    color: '#aaa',
    textDecoration: 'none',
    fontSize: '0.9rem'
  }
};
